import React from "react";

// Skeleton component for loading state
const StatCardSkeleton = () => (
  <div
    className="
      flex 
      items-center 
      w-full
      gap-3 sm:gap-4
      py-4 sm:py-5 px-4 sm:px-5
      md:flex-1 
      md:justify-center 
      md:py-[28px] 
      md:px-[20px]
      animate-pulse
    "
  >
    <div className="flex justify-center items-center flex-shrink-0">
      <div className="h-10 w-10 sm:h-[48px] sm:w-[48px] rounded-full bg-gray-200"></div>
    </div>
    <div className="text-left min-w-0 flex-1">
      <div className="h-3 w-20 bg-gray-200 rounded mb-2"></div>
      <div className="h-5 w-16 bg-gray-200 rounded"></div>
    </div>
  </div>
);

const StatsCardGroup = ({ stats, isLoading = false, skeletonCount = 5 }) => {
  return (
    <div
      className="
        w-full 
        bg-white 
        rounded-xl 
        border border-[#D9D9D9]
        mx-auto
        my-6

        overflow-hidden
      "
      style={{
        boxShadow: `
          inset 0px 12px 22px rgba(0,0,0,0.12),
          inset 12px -12px 24px rgba(0,0,0,0.07)
        `,
      }}
    >
      <div
        className="
          flex flex-col 
          divide-y divide-[#D9D9D9]

          md:flex-row 
          md:flex-wrap
          md:divide-y-0 
          md:divide-x

          lg:flex-nowrap  /* FIX: full row only at lg+ */
          p-6
        "
      >
        {isLoading
          ? Array.from({ length: skeletonCount }).map((_, index) => (
              <StatCardSkeleton key={index} />
            ))
          : stats.map((stat, index) => (
              <div
                key={index}
                className="
                  flex 
                  items-center 
                  w-full
                  gap-3 sm:gap-4
                  py-4 sm:py-5 px-4 sm:px-5

                  md:flex-1 
                  md:justify-center 
                  md:py-[28px] 
                  md:px-[20px]
                "
              >
                <div className="flex justify-center items-center flex-shrink-0">
                  <div className="h-10 w-10 sm:h-[48px] sm:w-[48px] rounded-full bg-toucanTeal flex items-center justify-center">
                    <span className="text-white text-xl sm:text-2xl">
                      {stat.icon}
                    </span>
                  </div>
                </div>

                <div className="text-left min-w-0 flex-1">
                  <p className="text-[10px] sm:text-[10px] text-gray-600 font-medium">
                    {stat.label}
                  </p>

                  <p className="text-lg sm:text-[20px] font-bold text-gray-900 mt-[2px]">
                    {stat.value}
                  </p>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default StatsCardGroup;
